import React, { useState , useEffect } from "react";
import { Card, Typography, Select, Button, DatePicker, Table } from "antd";
import {
  useFetchReportsByPeriodMutation,
  useFetchReportsQuery,
  useDeleteReportMutation,
} from "./reports.service";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import "./style.css";
import { CloudDownloadOutlined } from "@ant-design/icons";
import ProgressBar from "./progressbar";
import { useFetchChecklistSettingsQuery } from "../settings/setting.service";
import { Flex, Spin } from "antd";  // ✅ ADD Flex and Spin
import { useSelector } from "react-redux"; // ✅ ADD
import LocationSelector from "../../components/LocationSelector"; // ✅ ADD

const { Column } = Table;
dayjs.extend(isoWeek);

export default function Reports() {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const user = useSelector((state) => state.app.user);
const [locationId, setLocationId] = useState(null);
  const [period, setPeriod] = useState("thisWeek");
  const [startDate, setStartDate] = useState([
    dayjs().startOf('isoWeek'), // Monday
    dayjs().endOf('isoWeek')    // Sunday
  ]);

  // ✅ Set initial location from user
useEffect(() => {
  const locId = user?.activeLocationId || user?.restaurantId;
  if (locId) {
    setLocationId(locId);
  }
}, [user]);

const handleLocationChange = (newLocationId) => {
  setLocationId(newLocationId);
  refetchReports(); // Reports refetch karo
};
  useEffect(() => {
    if (period === 'thisWeek') {
      setStartDate([
        dayjs().startOf('isoWeek'),
        dayjs().endOf('isoWeek')
      ]);
    } else if (period === 'thisMonth') {
      setStartDate([
        dayjs().startOf('month'),
        dayjs().endOf('month')
      ]);
    }
  }, [period]);

  const [submitLoading, setSubmitLoading] = useState(false);
  const [progress, setProgress] = useState(0);

    // 🔥 FETCH CHECKLIST SETTINGS
  const { data: checklistSettingsResponse } = useFetchChecklistSettingsQuery(locationId, {
  skip: !locationId,
  refetchOnMountOrArgChange: true,
});
  const checklistSettings = checklistSettingsResponse?.data || checklistSettingsResponse || {};
  const showMonthly = checklistSettings?.monthly === true;

  const handleChange = (e) => {
    setPeriod(e);
  };

  const generatePDF = async (responseData) => {
    const element = document.createElement("div");
    element.style.padding = "50px";
    element.style.backgroundColor = "white";
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
    });
const margin = 50; // ✅ 30 se 50 kar do
const pageInnerHeight = pdf.internal.pageSize.getHeight() - 2 * margin;
const pageInnerWidth = pdf.internal.pageSize.getWidth() - 2 * margin;
    const RESOLUTION_MULTIPIER = 1.4;
    element.style.width = pageInnerWidth * RESOLUTION_MULTIPIER + "px";

const startDateMoment = moment.utc(
  responseData.startDate || (startDate[0] ? startDate[0].valueOf() : Date.now())
);
const endDateMoment = moment.utc(
  responseData.endDate || (startDate[1] ? startDate[1].valueOf() : Date.now())
);
// Helper function to create task HTML (same as before)
const createTaskHTML = (item) => {
  const backgroundColor = item.isSection ? "#e9edf6" : "transparent";
  
let commentText = "";
if (item.comment?.default && item.comment.default.toString().trim() !== '') {
  commentText = item.comment.default;
} else if (item.comment?.en && item.comment.en.toString().trim() !== '') {
  commentText = item.comment.en;
}
const hasComment = commentText !== "";
  
  // 🔥 Check if task has content (text field value)
let contentText = "";
if (item.content?.default && item.content.default.toString().trim() !== '') {
  contentText = item.content.default;
} else if (item.content?.en && item.content.en.toString().trim() !== '') {
  contentText = item.content.en;
}
const hasContent = contentText !== "";
  
  // 🔥 Check if task has temperature slider
  const hasTemperature = item.isTempSlider === true;
  const temperatureValue = hasTemperature ? `${item.tempSlider?.toFixed(1) || 0}°C` : "";
  
  // 🔥 Determine right side background color and text
  let rightSideBgColor = "transparent";
  let rightSideTextColor = "black";
  let rightSideHtml = "";
  
  if (!item.isSection) {
    if (hasComment) {
      // Has comment/note - Orange background
      rightSideBgColor = "#f97316"; // Dark orange
      rightSideTextColor = "white";
      
      if (hasTemperature) {
        // Temperature + NOTE
        rightSideHtml = `
          <div style="display: flex; flex-direction: column; gap: 4px; text-align: right;">
            <div style="font-size: 12px;">NOTE: ${commentText}</div>
            <div style="font-size: 14px; font-weight: bold;">${temperatureValue}</div>
          </div>
        `;
      } else {
        // Only NOTE
        rightSideHtml = `<div>NOTE: ${commentText}</div>`;
      }
    } 
    
  else if (item.isDateRecord && item.status === "completed") {
    rightSideBgColor = "#81b532";
    rightSideTextColor = "white";
    
    // Parse completedAt
    let completedTime = "";
    if (item.completedAt) {
      if (item.completedAt.$numberLong) {
        completedTime = moment(parseInt(item.completedAt.$numberLong)).format("MMM D, YYYY h:mm A");
      } else if (typeof item.completedAt === 'number') {
        completedTime = moment(item.completedAt).format("MMM D, YYYY h:mm A");
      } else if (typeof item.completedAt === 'string') {
        completedTime = moment(item.completedAt).format("MMM D, YYYY h:mm A");
      }
    }
    
    // Get content
    let contentTextForDate = "";
    if (item.content?.default && item.content.default.toString().trim() !== '') {
      contentTextForDate = item.content.default;
    }
    
    // Get slider value
    let sliderValueForDate = "";
    if (item.isTempSlider) {
      sliderValueForDate = `${item.tempSlider?.toFixed(1) || 0}°C`;
    }
    
    const parts = [];
    if (contentTextForDate) parts.push(`<div style="font-size: 12px;">${contentTextForDate}</div>`);
    if (sliderValueForDate) parts.push(`<div style="font-size: 14px; font-weight: bold;">${sliderValueForDate}</div>`);
    parts.push(`<div style="font-size: 11px;">${completedTime}</div>`);
    
    rightSideHtml = `
      <div style="display: flex; flex-direction: column; gap: 4px; text-align: right;">
        ${parts.join('')}
      </div>
    `;
  }


    else if (item.status === "completed") {
      // Completed - Green background
      rightSideBgColor = "#81b532";
      rightSideTextColor = "white";
      
      if (hasTemperature && hasContent) {
        // Temperature + Text content
        rightSideHtml = `
          <div style="display: flex; flex-direction: column; gap: 4px; text-align: right;">
            <div style="font-size: 12px;">${contentText}</div>
            <div style="font-size: 14px; font-weight: bold;">${temperatureValue}</div>
          </div>
        `;
      } else if (hasTemperature) {
        // Only temperature
        rightSideHtml = `<div style="font-weight: bold;">${temperatureValue}</div>`;
      } else if (hasContent) {
        // Only text content
        rightSideHtml = `<div>${contentText}</div>`;
      } else {
        // Default Yes
        rightSideHtml = `<span>✓ ${t("Yes")}</span>`;
      }
    }

    else if (hasTemperature) {
      // Not completed, only temperature
      rightSideHtml = `<div>${temperatureValue}</div>`;
    }
    else {
      // Not completed, no temperature
      rightSideHtml = `<span style="color: #ff6b6b;">${t("Not Completed")}</span>`;
    }
  }

  return `
    <div style="
      display: flex;
      border-bottom: ${!item.isSection ? "2px solid #e9edf6" : "none"};
      background-color: ${backgroundColor};
    ">
      <div style="flex-basis: 70%; padding: 12px 10px;">
        ${item["title"][language] || item["title"]["default"]}
      </div>
      <div style="
        flex-basis: 30%;
        padding: 12px 10px;
        background-color: ${rightSideBgColor};
        color: ${rightSideTextColor};
        text-align: right;
      ">
        ${rightSideHtml}
      </div>
    </div>
  `;
};
// Helper function to count tasks with comments
const countActions = (tasks) => {
  return tasks.filter(task => 
    task.comment && 
    task.comment.default && 
    task.comment.default.toString().trim() !== ''
  ).length;
};


    // Build the HTML content with bottom padding for page breaks (keeping your exact HTML structure)
  // Build the HTML content
element.innerHTML = `
   <!-- HEADER WITH LOGO AND REPORT INFO -->
    <div style="display: flex; align-items: center; margin-bottom: 30px; padding-bottom: 20px; border-bottom: 2px solid #333;">
      <!-- Logo Section -->
      <div style="flex: 0 0 100px; margin-right: 20px;">
        <img src="/icon.png" alt="Logo" style="width: 100%; height: auto; max-height: 80px; object-fit: contain;">
      </div>
      
      <!-- Report Title Section -->
      <div style="flex: 1;">
        <h1 style="margin: 0; font-size: 24px; color: #333;">Checklist Report</h1>
        <div style="margin-top: 8px; color: #666; font-size: 14px;">
          <div><strong>Generated:</strong> ${moment().format("MMMM D, YYYY h:mm A")}</div>
          <div><strong>Date Range:</strong> ${startDateMoment.format("MMMM D, YYYY")} - ${endDateMoment.format("MMMM D, YYYY")}</div>
          <!-- ✅ ADD USER NAME HERE -->
          <div><strong>Checked By:</strong> ${responseData.checkedBy || responseData.completedBy || responseData.userName || "Owner / Admin"}</div>
        </div>
      </div>
    </div>
      

    </div>

        ${responseData.isHolidayMode ? `
      <!-- HOLIDAY BANNER -->
      <div style="background: linear-gradient(135deg, #dc2626 0%, #991b1b 100%); color: white; padding: 20px; border-radius: 12px; margin-bottom: 30px; text-align: center;">
        <div style="font-size: 48px;">🏖️</div>
        <div style="font-size: 20px; font-weight: bold;">KITCHEN WAS ON HOLIDAY MODE</div>
        <div>${moment(responseData.holidayInfo?.startDate).format("MMMM D, YYYY")} - ${moment(responseData.holidayInfo?.endDate).format("MMMM D, YYYY")}</div>
      </div>
    ` : ""}

    ${responseData.closedDays && responseData.closedDays.length > 0 ? `
      <!-- CLOSED DAYS SECTION -->
      <div style="margin-bottom: 30px;">
        <div style="background: #f59e0b; color: white; padding: 12px; border-radius: 8px; margin-bottom: 16px;">
          🚫 Kitchen Was Closed On These Days
        </div>
        <div style="background: #fffbeb; border: 1px solid #fde68a; border-radius: 8px;">
          ${responseData.closedDays.map(day => `
            <div style="display: flex; padding: 10px; border-bottom: 1px solid #fde68a;">
              <div style="flex: 1;">${day.date}</div>
              <div style="flex: 1;">${day.dayName}</div>
              <div style="flex: 1; color: #d97706;">${day.reason}</div>
            </div>
          `).join("")}
        </div>
      </div>
    ` : ""}


  ${(() => {
    // Combine and sort all tasks by date
    const allTasks = [
      ...responseData.openingTasks.map((task) => ({
        ...task,
        type: "opening",
      })),
      ...responseData.closingTasks.map((task) => ({
        ...task,
        type: "closing",
      })),
      ...responseData.hotholdTasks.map((task) => ({
        ...task,
        type: "hothold",
      })),
      ...responseData.weeklyTasks.map((task) => ({
        ...task,
        type: "weekly",
      })),
      ...(responseData.monthlyTasks || []).map((task) => ({
        ...task,
        type: "monthly",
      })),
    ].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

    // Group tasks by date
    const tasksByDate = allTasks.reduce((acc, task) => {
      const date = moment.utc(task.createdAt).format("YYYY-MM-DD");
      if (!acc[date]) {
        acc[date] = {
          opening: [],
          closing: [],
          hothold: [],
          weekly: [],
          monthly: []
        };
      }
      acc[date][task.type].push(task);
      return acc;
    }, {});

    // Sort tasks by taskNumber
    Object.keys(tasksByDate).forEach((date) => {
      tasksByDate[date].opening.sort((a, b) => a.taskNumber - b.taskNumber);
      tasksByDate[date].closing.sort((a, b) => a.taskNumber - b.taskNumber);
      tasksByDate[date].hothold.sort((a, b) => a.taskNumber - b.taskNumber);
      tasksByDate[date].weekly.sort((a, b) => a.taskNumber - b.taskNumber);
      tasksByDate[date].monthly.sort((a, b) => a.taskNumber - b.taskNumber);
    });

    // Generate HTML for each date group
    return Object.entries(tasksByDate)
      .map(([date, tasks]) => {
        // Date header
        let html = `
          <div style="background-color: #f5f5f5; padding: 10px; margin: 10px 0;">
            <strong>End of day Report - ${moment.utc(date).format("MMMM D, YYYY")}</strong>
          </div>
        `;

// Opening Tasks with header and actions count
if (tasks.opening.length > 0) {
  const actionCount = countActions(tasks.opening);
  // ✅ Find any one name from tasks
let checkedByName = "Owner / Admin";
for (const task of tasks.opening) {
  if (task.completedByMemberName && task.completedByMemberName.trim() !== '') {
    checkedByName = task.completedByMemberName;
    break;
  }
}
  
  html += `
    <div style="display: flex; background-color: #e9edf6; padding: 8px; margin: 5px 0;">
      <div style="flex-basis: 40%;">
        <strong>${t("Opening Tasks")} (${tasks.opening.length})</strong>
      </div>
      <div style="flex-basis: 30%; text-align: center;">
        <strong>Checked By: ${checkedByName}</strong>
      </div>
      <div style="flex-basis: 30%; text-align: right;">
        <strong>Actions: ${actionCount}</strong>
      </div>
    </div>
    ${tasks.opening.map((item) => createTaskHTML(item)).join("")}
  `;
}

// Probe Tasks with header and actions count
if (tasks.hothold.length > 0) {
  const actionCount = countActions(tasks.hothold);
  
  // ✅ Find any one name from tasks
let checkedByName = "Owner / Admin";
for (const task of tasks.hothold) {
  if (task.completedByMemberName && task.completedByMemberName.trim() !== '') {
    checkedByName = task.completedByMemberName;
    break;
  }
}
  
  html += `
    <div style="display: flex; background-color: #e9edf6; padding: 8px; margin: 5px 0;">
      <div style="flex-basis: 40%;">
        <strong>${t("Probe Tasks")} (${tasks.hothold.length})</strong>
      </div>
      <div style="flex-basis: 30%; text-align: center;">
        <strong>Checked By: ${checkedByName}</strong>
      </div>
      <div style="flex-basis: 30%; text-align: right;">
        <strong>Actions: ${actionCount}</strong>
      </div>
    </div>
    ${tasks.hothold.map((item) => createTaskHTML(item)).join("")}
  `;
}
// Closing Tasks with header and actions count
if (tasks.closing.length > 0) {
  const actionCount = countActions(tasks.closing);
  
  // ✅ Find any one name from tasks
let checkedByName = "Owner / Admin";
for (const task of tasks.closing) {
  if (task.completedByMemberName && task.completedByMemberName.trim() !== '') {
    checkedByName = task.completedByMemberName;
    break;
  }
}
  
  html += `
    <div style="display: flex; background-color: #e9edf6; padding: 8px; margin: 5px 0;">
      <div style="flex-basis: 40%;">
        <strong>${t("Closing Tasks")} (${tasks.closing.length})</strong>
      </div>
      <div style="flex-basis: 30%; text-align: center;">
        <strong>Checked By: ${checkedByName}</strong>
      </div>
      <div style="flex-basis: 30%; text-align: right;">
        <strong>Actions: ${actionCount}</strong>
      </div>
    </div>
    ${tasks.closing.map((item) => createTaskHTML(item)).join("")}
  `;
}
// Weekly Tasks with header and actions count
if (tasks.weekly.length > 0) {
  const actionCount = countActions(tasks.weekly);
  
  // ✅ Find any one name from tasks
let checkedByName = "Owner / Admin";
for (const task of tasks.weekly) {
  if (task.completedByMemberName && task.completedByMemberName.trim() !== '') {
    checkedByName = task.completedByMemberName;
    break;
  }
}
  
  html += `
    <div style="display: flex; background-color: #e9edf6; padding: 8px; margin: 5px 0;">
      <div style="flex-basis: 40%;">
        <strong>${t("Weekly Tasks")} (${tasks.weekly.length})</strong>
      </div>
      <div style="flex-basis: 30%; text-align: center;">
        <strong>Checked By: ${checkedByName}</strong>
      </div>
      <div style="flex-basis: 30%; text-align: right;">
        <strong>Actions: ${actionCount}</strong>
      </div>
    </div>
    ${tasks.weekly.map((item) => createTaskHTML(item)).join("")}
  `;
}
        // Monthly Tasks with header and actions count
// Monthly Tasks with header and actions count
if (tasks.monthly.length > 0) {
  const actionCount = countActions(tasks.monthly);
  
  // ✅ Find any one name from tasks
let checkedByName = "Owner / Admin";
for (const task of tasks.monthly) {
  if (task.completedByMemberName && task.completedByMemberName.trim() !== '') {
    checkedByName = task.completedByMemberName;
    break;
  }
}
  
  html += `
    <div style="display: flex; background-color: #e9edf6; padding: 8px; margin: 5px 0;">
      <div style="flex-basis: 40%;">
        <strong>${t("Monthly Tasks")} (${tasks.monthly.length})</strong>
      </div>
      <div style="flex-basis: 30%; text-align: center;">
        <strong>Checked By: ${checkedByName}</strong>
      </div>
      <div style="flex-basis: 30%; text-align: right;">
        <strong>Actions: ${actionCount}</strong>
      </div>
    </div>
    ${tasks.monthly.map((item) => createTaskHTML(item)).join("")}
  `;
}

        return html;
      })
      .join("");
  })()}

     <!-- ========== INCIDENTS SECTION ========== -->
    <div style="margin: 20px 0 15px 0;">
    <!-- Section Heading - Light Blue -->
    <div style="background-color: #e6f0ff; padding: 8px; margin-bottom: 6px;">
      <div style="display: flex; justify-content: space-between;">
        <strong>Incidents</strong>
        <span>${responseData.incidents?.length || 0}</span>
      </div>
    </div>
${responseData.incidents && responseData.incidents.length > 0 ? 
  `
  <!-- Header Row -->
  <div style="display: flex; border-bottom: 1px solid #ddd; padding: 6px 0;">
    <div style="flex: 4;"><strong>Issue</strong></div>
    <div style="flex: 2;"><strong>Employee</strong></div>
    <div style="flex: 2;"><strong>Time</strong></div>
    <div style="flex: 2; text-align: right;"><strong>Resolution</strong></div>
  </div>
  ${responseData.incidents.map((item) => {
    const issue = item["incident"][language] || item["incident"]["default"] || "";
    const employee = item.employeeName || item.completedByMemberName || "-";
    const time = moment.utc(item.createdAt || item.reportedAt).format("MMM D, YYYY - hh:mm A");
    const resolution = item["resolution"][language] || item["resolution"]["default"] || "";
    
    return `
      <div style="display: flex; border-bottom: 1px solid #eee; padding: 6px 0;">
        <div style="flex: 4;">${issue}</div>
        <div style="flex: 2;">${employee}</div>
        <div style="flex: 2;">${time}</div>
        <div style="flex: 2; text-align: right;">${resolution}</div>
      </div>
    `;
  }).join("")}
  `
  : `
    <div style="text-align: center; padding: 20px; color: #999; font-style: italic; border: 1px dashed #ccc; border-radius: 4px;">
      No incidents recorded.
    </div>
  `
}
  </div>

    <!-- ========== CLEANING LOG SECTION ========== -->
    <div style="margin: 20px 0 15px 0;">
    <div style="background-color: #e6f0ff; padding: 8px; margin-bottom: 6px;">
      <div style="display: flex; justify-content: space-between;">
        <strong>Cleaning log</strong>
        <span>${responseData.cleaningLogs?.length || 0}</span>
      </div>
    </div>
${responseData.cleaningLogs && responseData.cleaningLogs.length > 0 ?
  `
  <div style="display: flex; border-bottom: 1px solid #ddd; padding: 6px 0;">
    <div style="flex: 3;"><strong>Item cleaned</strong></div>
    <div style="flex: 2;"><strong>Cleaned by</strong></div>
    <div style="flex: 2;"><strong>Time</strong></div>
    <div style="flex: 3;"><strong>Notes</strong></div>
    <div style="flex: 1; text-align: right;"><strong>Photo</strong></div>
  </div>
  ${responseData.cleaningLogs.map((item) => {
    const time = moment.utc(item.cleanedAt || item.createdAt).format("MMM D, YYYY - hh:mm A");
    const notes = item.notes || "-";
    const photo = item.photoUrl ? "Yes" : "-";
    return `
      <div style="display: flex; border-bottom: 1px solid #eee; padding: 6px 0;">
        <div style="flex: 3;">${item.itemName || "-"}</div>
        <div style="flex: 2;">${item.cleanedByName || "-"}</div>
        <div style="flex: 2;">${time}</div>
        <div style="flex: 3;">${notes}</div>
        <div style="flex: 1; text-align: right;">${photo}</div>
      </div>
    `;
  }).join("")}
  `
  : `
    <div style="text-align: center; padding: 20px; color: #999; font-style: italic; border: 1px dashed #ccc; border-radius: 4px;">
      No cleaning records in this period.
    </div>
  `
}
  </div>

    <!-- ========== CHECKLIST INCIDENTS SECTION ========== -->
  <div style="margin: 20px 0 15px 0;">
    <!-- Section Heading - Light Blue -->
    <div style="background-color: #e6f0ff; padding: 8px; margin-bottom: 6px;">
      <div style="display: flex; justify-content: space-between;">
        <strong>Checklist Incidents</strong>
        <span>${(() => {
          // Calculate total checklist incidents
          let total = 0;
          const checkTypes = ['openingTasks', 'closingTasks', 'hotholdTasks', 'weeklyTasks', 'monthlyTasks'];
          for (const type of checkTypes) {
            if (responseData[type]) {
              total += responseData[type].filter(t => t.comment?.default && t.comment.default.trim() !== '').length;
            }
          }
          return total;
        })()}</span>
      </div>
    </div>
    
    ${(() => {
      // Group checklist incidents by type
      const groupedChecklist = {
        "Opening Tasks": (responseData.openingTasks || []).filter(item => item.comment?.default && item.comment.default.trim() !== ''),
        "Probe / Hot Hold Tasks": (responseData.hotholdTasks || []).filter(item => item.comment?.default && item.comment.default.trim() !== ''),
        "Closing Tasks": (responseData.closingTasks || []).filter(item => item.comment?.default && item.comment.default.trim() !== ''),
        "Weekly Tasks": (responseData.weeklyTasks || []).filter(item => item.comment?.default && item.comment.default.trim() !== ''),
        "Monthly Tasks": (responseData.monthlyTasks || []).filter(item => item.comment?.default && item.comment.default.trim() !== ''),
      };
      
      const hasAny = Object.values(groupedChecklist).some(arr => arr.length > 0);
      
      if (!hasAny) {
        return `
          <div style="text-align: center; padding: 20px; color: #999; font-style: italic; border: 1px dashed #ccc; border-radius: 4px;">
            No checklist incidents reported.
          </div>
        `;
      }
      
      let html = '';
      for (const [groupName, items] of Object.entries(groupedChecklist)) {
        if (items.length === 0) continue;
        
        html += `
          <!-- Group Title - Left border only -->
          <div style="padding: 6px 8px; margin-top: 4px;">
            <strong>${groupName}</strong>
          </div>
        `;
        
        for (const item of items) {
          // Get comment text (default first, then en)
          let commentText = "";
          if (item.comment?.default && item.comment.default.trim() !== '') {
            commentText = item.comment.default;
          } else if (item.comment?.en && item.comment.en.trim() !== '') {
            commentText = item.comment.en;
          }
          
          // Get title
          let title = item.title?.default || item.title_en || "";
          title = title.replace(/<[^>]*>/g, '').trim();
          
          const date = moment.utc(item.createdAt).format("MMM D, YYYY - hh:mm A");
          
          html += `
            <div style="display: flex; justify-content: space-between; border-bottom: 1px solid #eee; padding: 8px 8px;">
              <div style="flex: 2; color: #666; font-size: 12px;">${date}</div>
              <div style="flex: 1; text-align: right; color: #dc2626; font-size: 12px;">${commentText}</div>
            </div>
          `;
        }
      }
      return html;
    })()}
  </div>
 
  
  
    <!-- ========== DELIVERIES SECTION ========== -->
  <div style="margin: 20px 0 15px 0;">
    <!-- Section Heading - Light Blue -->
    <div style="background-color: #e6f0ff; padding: 8px; margin-bottom: 6px;">
      <div style="display: flex; justify-content: space-between;">
        <strong>Deliverys</strong>
        <span>${responseData.deliveries?.length || 0}</span>
      </div>
    </div>
    
    ${responseData.deliveries && responseData.deliveries.length > 0 ? 
      `
      <!-- Header Row -->
      <div style="display: flex; border-bottom: 1px solid #ddd; padding: 6px 0;">
        <div style="flex: 3;"><strong>Created At</strong></div>
        <div style="flex: 3;"><strong>Supplier Name</strong></div>
        <div style="flex: 2;"><strong>Delivery Type</strong></div>
        <div style="flex: 2; text-align: center;"><strong>Is Intact</strong></div>
        <div style="flex: 2; text-align: center;"><strong>Temperature</strong></div>
        <div style="flex: 3; text-align: right;"><strong>Delivery Ref / Comment</strong></div>
      </div>
      ${responseData.deliveries.map((item) => {
        const commentText = typeof item.comment === "string"
          ? item.comment
          : (item.comment?.default || item.comment?.en || "");
        const refAndComment = [item.invoiceRef, commentText]
          .filter((v) => v && String(v).trim() !== "")
          .join(" — ") || "-";
        return `
          <div style="display: flex; border-bottom: 1px solid #eee; padding: 6px 0;">
            <div style="flex: 3;">${moment.utc(item.createdAt).format("MMM D, YYYY h:mm a")}</div>
            <div style="flex: 3;">${item.supplierName || "-"}</div>
            <div style="flex: 2;">${item.deliveryType || "-"}</div>
            <div style="flex: 2; text-align: center;">${item.isIntact ? "Yes" : "No"}</div>
            <div style="flex: 2; text-align: center;">${item.temperature?.toFixed(1) || "-"}°C</div>
            <div style="flex: 3; text-align: right;">${refAndComment}</div>
          </div>
        `;
      }).join("")}
      `
      : `
        <div style="text-align: center; padding: 20px; color: #999; font-style: italic; border: 1px dashed #ccc; border-radius: 4px;">
          No deliveries recorded for this period.
        </div>
      `
    }
  </div>
`;

    // Temporarily append to document (hidden)
    element.style.position = "absolute";
    element.style.left = "-9999px";
    document.body.appendChild(element);

    try {
      // Calculate total items for optimization
      const totalItems =
        responseData.openingTasks.length +
        responseData.closingTasks.length +
        responseData.hotholdTasks.length +
        responseData.weeklyTasks.length +
        responseData.incidents.length +
        (responseData.cleaningLogs?.length || 0) +
        responseData.deliveries.length;

      // Dynamic settings based on data size
      const isLargeDataset = totalItems > 150;
      const scale = isLargeDataset ? 0.8 : 1.0;
      const quality = isLargeDataset ? 0.75 : 0.9;

      // Helper function to get DOM height (simple measurement, no calculations)
      const getDOMHeight = (child) => {
        return child.getBoundingClientRect().height;
      };

      const pageGroups = [];
      let currentGroup = [];
      let currentGroupHeight = 0; // Track DOM height directly

      // Process each child element using simple DOM height
      for (let i = 0; i < element.children.length; i++) {
        const child = element.children[i];

        // Get simple DOM height (no conversions)
        const domHeight = getDOMHeight(child);

        if (
          currentGroupHeight + domHeight >
            pageInnerHeight * RESOLUTION_MULTIPIER &&
          currentGroup.length > 0
        ) {
          // Start new page group
          pageGroups.push({
            elements: [...currentGroup],
            totalHeight: currentGroupHeight,
          });

          currentGroup = [child];
          currentGroupHeight = domHeight;
        } else {
          // Add to current group
          currentGroup.push(child);
          currentGroupHeight += domHeight;
        }
      }

      // Add the last group
      if (currentGroup.length > 0) {
        pageGroups.push({
          elements: [...currentGroup],
          totalHeight: currentGroupHeight - margin,
        });
      }

      for (let groupIndex = 0; groupIndex < pageGroups.length; groupIndex++) {
        const group = pageGroups[groupIndex];
        setProgress(((groupIndex + 1) / pageGroups.length) * 100);

        // Create a container for this group
        const groupContainer = document.createElement("div");
        groupContainer.style.cssText = `
          padding: 0;
          background-color: white;
          width: ${pageInnerWidth * RESOLUTION_MULTIPIER}px;
          position: absolute;
          left: -9999px;
        `;

        // Add all elements from this group to the container
        group.elements.forEach((el) => {
          const clone = el.cloneNode(true);
          groupContainer.appendChild(clone);
        });

        document.body.appendChild(groupContainer);

        try {
          // Create canvas for entire group (ONLY TIME WE USE CANVAS)
          const canvas = await html2canvas(groupContainer, {
            scale: scale,
            logging: false,
            useCORS: true,
            allowTaint: true,
            backgroundColor: "#ffffff",
            removeContainer: false,
            imageTimeout: 0,
            onclone: (clonedDoc) => {
              const style = clonedDoc.createElement("style");
              style.textContent = `
                * { 
                  animation: none !important; 
                  transition: none !important; 
                  transform: none !important;
                  box-shadow: none !important;
                }
              `;
              clonedDoc.head.appendChild(style);
            },
          });

          const imgData = canvas.toDataURL("image/jpeg", quality);
          const imgWidth = pdf.internal.pageSize.getWidth() - margin * 2;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;

          // Add new page for each group (except first)
          if (groupIndex > 0) {
            pdf.addPage();
          }

          // Add the group image to PDF
          pdf.addImage(imgData, "JPEG", margin, margin, imgWidth, imgHeight);
        } catch (error) {
          console.error(`Error processing group ${groupIndex + 1}:`, error);
        } finally {
          // Clean up group container
          if (document.body.contains(groupContainer)) {
            document.body.removeChild(groupContainer);
          }
        }
      }

      const fileName = `report-${dayjs().format("YYYY-MM-DD-HH-mm")}.pdf`;
      pdf.save(fileName);
      setSubmitLoading(false);
    } catch (error) {
      setSubmitLoading(false);
      setProgress(0);
      console.error("Error generating PDF:", error);
      toast.error(t("Error generating PDF"));
    } finally {
      setSubmitLoading(false);
      setProgress(0);
      if (document.body.contains(element)) {
        document.body.removeChild(element);
      }
    }
  };

  const [
    requestFetchReportsByPeriod,
    {
      data = {
        reportData: {
          closingTasks: [],
          incidents: [],
          openingTasks: [],
          sensorData: [],
          monthlyTasks: []
        },
      },
      isLoading,
    },
  ] = useFetchReportsByPeriodMutation();

const { 
  data: reportData = { data: { reports: [] } }, 
  refetch: refetchReports,
  isFetching: isReportsFetching,
} = useFetchReportsQuery(locationId, {
  skip: !locationId,
  refetchOnMountOrArgChange: true,
});

const handleReportsDownload = async (item) => {
  if (!locationId) {
    toast.error("Please select a location first");
    return;
  }
  
  setSubmitLoading(true);
  if (!item) return;
  
  const response = await requestFetchReportsByPeriod({
    params: item,
    locationId, // ✅ ADD
  });
  if (response.data?.reportData) generatePDF(response.data.reportData);
};

const getDateRangeTimestamps = (start, end) => {
  if (!start || !end) return null;

  // ✅ UTC start/end of day - no timezone involved
  const startTimestamp = start.utc().startOf('day').valueOf();
  const endTimestamp = end.utc().endOf('day').valueOf();

  // console.log("✅ UTC DATE RANGE:", {
  //   from: start.utc().format("YYYY-MM-DD") + " 00:00:00 UTC",
  //   to: end.utc().format("YYYY-MM-DD") + " 23:59:59 UTC",
  //   timestamps: { start: startTimestamp, end: endTimestamp }
  // });

  return { startTimestamp, endTimestamp };
};

  const {
    data: { reports },
  } = reportData;

  const [deleteReport] = useDeleteReportMutation();

  const handleDeleteReport = async (reportId) => {
  try {
    await deleteReport({ 
      logId: reportId,
      locationId // ✅ ADD
    });
    toast.success(t("Report deleted successfully"));
    refetchReports();
  } catch (error) {
    toast.error(t("Failed to delete report"));
  }
};

return (
  <Spin spinning={isReportsFetching}>
    <Card 
      className="reports-page" 
      bordered={false}
      title={
        <Flex align="center" gap="middle" wrap>
          <span>{t("Reports")}</span>
          <LocationSelector onLocationChange={handleLocationChange} />
        </Flex>
      }
    >
      {!locationId ? (
        <div style={{ textAlign: "center", padding: "40px", color: "#999" }}>
          {t("Please select a location to view reports")}
        </div>
      ) : (
        <>
          <div className="reports-page-container">
            <h2>{t("Select your report frequency")}</h2>
            <p>{t("Please choose the report range below")}</p>
            <Typography.Title level={5}>{t("Time Period")}</Typography.Title>
            <Select
              style={{ width: "100%" }}
              value={period}
              onChange={handleChange}
              options={[
                { label: t("thisWeek"), value: "thisWeek" },
                { label: t("thisMonth"), value: "thisMonth" },
                { label: t("Custom"), value: "custom" },
              ]}
            />

            <div className="reports-page-container-datepicker">
              <div className="reports-page-container-datepicker-start">
                <DatePicker.RangePicker
                  style={{ width: "100%" }}
                  disabled={period === "custom" ? false : true}
                  onChange={(dates) => {
                    if (dates) {
                      setStartDate(dates);
                    }
                  }}
                  value={startDate}
                  allowClear={false}
                  name="report-date-picker"
                />
              </div>
            </div>

            <div className="reports-page-container-description">
              {t("What the report will contain:")}
            </div>
            <p className="reports-page-container-description-content">
              {t("Opening Checks")}<br />
              {t("Closing Checks")}<br />
              {t("Hot Hold and Chill Checks")}<br />
              {t("Weekly Checks")}<br />
              {showMonthly && (
                <>
                  {t("Monthly Checks")}<br />
                </>
              )}
              {t("Temperature readings")}<br />
              {t("Incidents Logged")}<br />
              {t("Deliveries")}
            </p>

            <Button
              type="primary"
              loading={submitLoading}
              onClick={() => {
                let startTimestamp, endTimestamp;

                if (period === "custom") {
                  if (!startDate || startDate.length !== 2) {
                    toast.error(t("Please input the date"));
                    return;
                  }
                  const range = getDateRangeTimestamps(startDate[0], startDate[1]);
                  startTimestamp = range.startTimestamp;
                  endTimestamp = range.endTimestamp;
                } else if (period === "thisWeek") {
                  const startOfWeek = dayjs().startOf("isoWeek");
                  const endOfWeek = dayjs().endOf("isoWeek");
                  const range = getDateRangeTimestamps(startOfWeek, endOfWeek);
                  startTimestamp = range.startTimestamp;
                  endTimestamp = range.endTimestamp;
                } else if (period === "thisMonth") {
                  const startOfMonth = dayjs().startOf("month");
                  const endOfMonth = dayjs().endOf("month");
                  const range = getDateRangeTimestamps(startOfMonth, endOfMonth);
                  startTimestamp = range.startTimestamp;
                  endTimestamp = range.endTimestamp;
                }

                handleReportsDownload({
                  period,
                  startDate: startTimestamp,
                  endDate: endTimestamp,
                  log: true,
                });
              }}
            >
              {t("Submit")}
            </Button>
          </div>

          <Card className="reports-page-list" title={t("Reports Created")}>
            <Table 
              dataSource={reports} 
              rowKey="_id"
              locale={{ emptyText: t("No reports found for this location") }}
            >
              <Column
                title={t("Created")}
                dataIndex={"generated_at"}
                render={(generatedAt) =>
                  moment(generatedAt).format("YYYY-MM-DD HH:mm")
                }
                align="center"
              />
              <Column
                align="center"
                title={t("Date Range")}
                render={(_, record) =>
                  `${moment.utc(record.startDate).format("YYYY-MM-DD")} - ${moment
                    .utc(record.endDate)
                    .format("YYYY-MM-DD")}`
                }
              />
              <Column
                align="center"
                title={t("Status")}
                render={(_, record) => (
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      handleReportsDownload({
                        period: record.periodType,
                        startDate: record.startDate,
                        endDate: record.endDate,
                        log: false,
                      })
                    }
                  >
                    <CloudDownloadOutlined /> {t("Download")}
                  </div>
                )}
              />
              <Column
                align="center"
                title={t("Actions")}
                render={(_, record) => (
                  <Button
                    type="link"
                    danger
                    onClick={() => handleDeleteReport(record._id)}
                  >
                    {t("Delete")}
                  </Button>
                )}
              />
            </Table>
          </Card>
          {submitLoading && <ProgressBar progress={progress} />}
        </>
      )}
    </Card>
  </Spin>
);
}
